import type { Adventure } from '../../types'

// Age 3: Number Rainbow - Number Recognition with Colors
export const numberRainbowAdventure: Adventure = {
  id: 'number-rainbow',
  title: 'Rainbow Numbers',
  theme: 'numbers',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 5,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello rainbow friend! Numbers are like rainbow colors! Each number is special and colorful! Let us find them!",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at this beautiful rainbow! The first color is RED, and the first number is ONE! Can you find number one?",
      duration: 5,
      background: 'rainbow-sky'
    },
    choice1: [
      {
        id: 'find-one',
        label: "Find number one!",
        tillyLine: "Number one is the first number! Look for the single red number!",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'number-recognition',
      question: 'Find number 1!',
      tillyPrompt: 'Which one is number one?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '1', label: '1', isCorrect: true },
        { id: '3', label: '3', isCorrect: false }
      ],
      targetNumber: 1
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Wonderful! You found number one! Now look at the orange part of the rainbow! Orange is the color of number two!",
      duration: 5,
      background: 'rainbow-sky'
    },
    choice2: [
      {
        id: 'find-two',
        label: "Find number two!",
        tillyLine: "Number two is orange! Can you spot it?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'number-recognition',
      question: 'Find number 2!',
      tillyPrompt: 'Where is number two?',
      options: [
        { id: '3', label: '3', isCorrect: false },
        { id: '2', label: '2', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      targetNumber: 2
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Rainbow champion! Time for the color challenge! Let us find numbers three, four, and five!",
        duration: 5,
        background: 'rainbow-sky'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'number-recognition',
          question: 'Find number 3!',
          tillyPrompt: 'Which is number three?',
          options: [
            { id: '3', label: '3', isCorrect: true },
            { id: '2', label: '2', isCorrect: false },
            { id: '4', label: '4', isCorrect: false }
          ],
          targetNumber: 3
        } as any
      ]
    },
    reward: {
      tillyLine: "Colorful success! You found all the rainbow numbers! You are a Rainbow Number Expert!",
      badgeName: 'Rainbow Number Expert',
      badgeIcon: '🌈',
      nextPreview: 'Next time, we will count more things!'
    }
  }
}

export const tillyRainbowCorrect = [
  "Colorful and correct!",
  "Rainbow bright! You got it!",
  "Shiny and right! Perfect!",
  "Spectrum success! Amazing!",
  "Hues of brilliance! Correct!",
  "Painted with perfection!",
  "Color champion! You did it!",
  "Vibrant victory! Great job!",
  "Rainbow radiance!",
  "Prism perfect! Success!"
]

export const tillyRainbowWrong = [
  "Almost! Look for the color!",
  "Not quite! Check the rainbow!",
  "Good try! Find the number!",
  "Close! Look at the colors!",
  "That is okay! Rainbows are tricky!",
  "Keep trying! Color your world!",
  "Almost there! Bright idea coming!",
  "Try once more! Rainbow power!",
  "Not yet! Shine on!",
  "Paint it again! Try once more!"
]

export const tillyRainbowCelebration = [
  "🌈 Rainbow number champion! 🌈",
  "Colors of success for you! 🌟",
  "Bright and brilliant winner! 🏆",
  "Rainbow mastery achieved! 🎊",
  "Colorful math superstar! 🥇"
]
